import { render, staticRenderFns } from "./dados-pessoais.vue?vue&type=template&id=587473d2"
import script from "./dados-pessoais.vue?vue&type=script&lang=js"
export * from "./dados-pessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports